<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Compare Propulsion Scenario Volume Report</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="report-button" class="action-button"
            [disabled]="!(selectedReportType && areScenariosSelected)"
            (click)="onRunReport()">
      Run Report
    </button>
  </div>
</div>
<div id="main-content" class="d-flex gap-16 align-content-between">
  <!-- Filter Dropdowns -->
  <div id="filters" class="filter-container d-flex flex-column gap-8">
    <mat-form-field class="default-margin report-type" subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Report Type</mat-label>
      <mat-select id="report-type-select" [(ngModel)]="selectedReportType" (selectionChange)="setScenariosSelected()">
        <mat-option [value]="WORKING_VS_COMPARE">Working Scenario vs Compare Scenario</mat-option>
        <mat-option [value]="YR_OVER_YR">Year Over Year in Working Scenario</mat-option>
      </mat-select>
    </mat-form-field>
    <h3>Filter By:</h3>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label [ngClass]="{'disabled-text': !areScenariosSelected}">Choose Geography</mat-label>
      <mat-select name="geography" id="geography" required [(ngModel)]="selectedGeography"
                  [disabled]="!areScenariosSelected">
        <mat-option [value]="SUBREGION_FLAG">Subregion</mat-option>
        <mat-option *ngIf="!isGlobal" [value]="MKTAREA_FLAG">Market Area</mat-option>
        <mat-option [value]="PLNGMKT_FLAG">Planning Market</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="selectedGeography && areScenariosSelected">
      <mat-form-field *ngIf="selectedGeography === SUBREGION_FLAG" subscriptSizing="dynamic" class="filter-options">
        <mat-label>Subregion</mat-label>
        <fab-multiselect
          name="subregionFilter"
          [(ngModel)]="geographyOptions.selectedOptions"
          (ngModelChange)="onFilterChange(SUBREGION)"
          [options]="geographyOptions.options">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field *ngIf="selectedGeography === MKTAREA_FLAG" subscriptSizing="dynamic" class="filter-options">
        <mat-label>Market Area</mat-label>
        <mat-select id="mktAreaFilter"
                    [(ngModel)]="geographyOptions.selectedOptions"
                    (selectionChange)="onFilterChange(MKTAREA)">
          <mat-option *ngFor="let mktArea of geographyOptions.options"
                      [value]="[mktArea]">{{ mktArea }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="selectedGeography === PLNGMKT_FLAG" subscriptSizing="dynamic" class="filter-options">
        <mat-label>Planning Market</mat-label>
        <fab-multiselect
          name="plngMktFilter"
          [(ngModel)]="geographyOptions.selectedOptions"
          (ngModelChange)="onFilterChange(PLNGMKT)"
          [options]="geographyOptions.options">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="filter-options">
        <mat-label>Brand</mat-label>
        <fab-multiselect
          name="brandFilter"
          [(ngModel)]="brandOptions.selectedOptions"
          (ngModelChange)="onFilterChange(BRAND)"
          [options]="brandOptions.options">
        </fab-multiselect>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="filter-options">
        <mat-label>Program Code</mat-label>
        <fab-multiselect
          name="prgmCodeFilter"
          [(ngModel)]="prgmCodeOptions.selectedOptions"
          (ngModelChange)="onFilterChange(PRGMCODE)"
          [options]="prgmCodeOptions.options">
        </fab-multiselect>
      </mat-form-field>
      <div class="d-flex gap-8 flex-row justify-content-center">
        <mat-form-field class="default-margin" subscriptSizing="dynamic">
          <mat-label class="asterisk--before">Start Year</mat-label>
          <mat-select [(ngModel)]="startYear" id="startYear">
            <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="default-margin" subscriptSizing="dynamic">
          <mat-label class="asterisk--before">End Year</mat-label>
          <mat-select [(ngModel)]="endYear" id="endYear">
            <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
  </div>
  <div id="scenario-content" class="d-flex flex-column gap-8 w-100">
    <!-- Scenario type toggle -->
    <div class="d-flex flex-column justify-content-center">
      <mat-button-toggle-group [(ngModel)]="isGlobal"
                               hideSingleSelectionIndicator="true"
                               (ngModelChange)="setScenariosSelected()">
        <mat-button-toggle id="forecast-org-toggle" [value]="false" class="flex-grow-1">
          By Forecast Org
        </mat-button-toggle>
        <mat-button-toggle id="global-scenario-toggle" [value]="true" class="flex-grow-1">
          By Global Scenario
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <!--If user is working with Vehicle Scenarios -->
    <div id="scenario-container" *ngIf="!isGlobal">
      <table [ngClass]="{'half-width': selectedReportType === YR_OVER_YR}">
        <tr>
          <td></td>
          <td class="working-scenario-content-border working-scenario-content-border-top column-header">
            <h2><b>Working Scenario</b></h2>
            <h3 *ngIf="!selectedWorkingScenario" style="font-style: italic">Select Scenario
              Below</h3>
          </td>
          <td class="column-header" *ngIf="selectedReportType === WORKING_VS_COMPARE">
            <h2 [ngClass]="{'disabled-text': !selectedWorkingScenario}"><b>Compare Scenario</b></h2>
          </td>
        </tr>

        <!-- FORECAST ORG ROW -->
        <tr>
          <td class="scenario-labels">Forecast Organization</td>
          <td *ngIf="selectedWorkingScenario" class="working-scenario-content-border">
            <div class="column-content">
              <span class="column-text">{{ selectedWorkingScenario.fcorg }}</span>
            </div>
          </td>
          <td *ngIf="selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE">
            <div class="column-content">
              <span class="column-text">{{ selectedCompareScenario.fcorg }}</span>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedWorkingScenario" class="working-scenario-content-border column-content"></td>
          <td *ngIf="!selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE"></td>
        </tr>

        <!-- VEHICLE SCENARIO ROW -->
        <tr class="light-gray-background">
          <td class="scenario-labels">Vehicle Scenario</td>
          <td *ngIf="selectedWorkingScenario"
              class="working-scenario-content-border">
            <div class="column-content">
          <span class="column-text pad-left-50">{{ selectedWorkingScenario.vehScenId }}
            - {{ selectedWorkingScenario.vehScenName }}</span>
              <button mat-icon-button [matMenuTriggerFor]="vehicleMenu" class="vertical-dots" matTooltip="More options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #vehicleMenu="matMenu">
                <button mat-menu-item (click)="openVehSelectComponent()" class="menu-width">
                  <mat-icon>autorenew</mat-icon>
                  <span>Change Scenario</span>
                </button>
              </mat-menu>
            </div>
          </td>
          <td *ngIf="selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE">
            <div class="column-content">
          <span class="column-text pad-left-50">{{ selectedCompareScenario.vehScenId }}
            - {{ selectedCompareScenario.vehScenName }}</span>
              <button mat-icon-button [matMenuTriggerFor]="compareVehicleMenu" class="vertical-dots"
                      matTooltip="More options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #compareVehicleMenu="matMenu">
                <button mat-menu-item (click)="selectCompareScenario()" class="menu-width">
                  <mat-icon>autorenew</mat-icon>
                  <span>Change Scenario</span>
                </button>
              </mat-menu>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedWorkingScenario" class="working-scenario-content-border column-content">
          <span class="hyperlink"
                tabindex="0"
                (click)="openVehSelectComponent()"
                (keydown.enter)="openVehSelectComponent()">Select Vehicle Scenario</span>
          </td>
          <td *ngIf="!selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE"></td>
        </tr>

        <!-- PROPULSION SCENARIO ROW -->
        <tr>
          <td class="scenario-labels">Propulsion Scenario</td>
          <td *ngIf="selectedWorkingScenario"
              class="working-scenario-content-border working-scenario-content-border-bottom">
            <div class="column-content">
          <span class="column-text">{{ selectedWorkingScenario.propulsionScenario.id }}
            - {{ selectedWorkingScenario.propulsionScenario.propulsionScenarioName }}</span>
            </div>
          </td>
          <td *ngIf="selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE">
            <div class="column-content">
          <span class="column-text">{{ selectedCompareScenario.propulsionScenario.id }}
            - {{ selectedCompareScenario.propulsionScenario.propulsionScenarioName }}</span>
            </div>
          </td>
          <!-- if no selected scenarios -->
          <td *ngIf="!selectedWorkingScenario"
              class="working-scenario-content-border working-scenario-content-border-bottom column-content"></td>
          <td *ngIf="!selectedCompareScenario && selectedReportType === WORKING_VS_COMPARE"></td>
        </tr>

      </table>
    </div>
    <div *ngIf="isGlobal">
      <ng-container>
        <h3>Working Global Scenario</h3>
        <app-global-scenario-select-component
          class="content-height d-flex"
          [user]="stateService.getUserGmid()"
          [filterNonGM]="false"
          [memberScenarioType]="0"
          (confirmEvent)="onGlobalScenarioSelect($event)"></app-global-scenario-select-component>
      </ng-container>

      <mat-divider></mat-divider>
      <!-- Only show the compare scenario selection if they are using the Working vs Compare report type -->
      <ng-container *ngIf="selectedReportType === WORKING_VS_COMPARE">
        <h3>Compare Global Scenario</h3>
        <app-global-scenario-select-component
          class="content-height d-flex"
          [user]="stateService.getUserGmid()"
          [filterNonGM]="false"
          [memberScenarioType]="0"
          (confirmEvent)="onCompareGlobalScenarioSelect($event)"></app-global-scenario-select-component>
      </ng-container>
    </div>
  </div>
</div>


